// extracted by mini-css-extract-plugin
module.exports =  {"icon":"icon_C2WQKVOh","workspaceLink":"workspaceLink_I1MCNBQc"};